module.exports = "https://la-static.vkplay.ru/promo/universal/img/button-big-bg.f2cc4e87.png";